import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: true,
  imports: [IonApp, IonRouterOutlet, NgxUiLoaderModule]
})
export class AppComponent implements OnInit {
  constructor(private router: Router) { }
  ngOnInit() {
    if (environment.production && environment.gaMeasurementId) {
      this.addGAScript(environment.gaMeasurementId);

      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        gtag('config', environment.gaMeasurementId, {
          page_path: event.urlAfterRedirects
        });
      });
    }
  }

  addGAScript(measurementId: string) {
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.text = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${measurementId}');
    `;
    document.head.appendChild(script2);
  }
}
